// extracted by mini-css-extract-plugin
module.exports = {"container":"_3526lRs8I6IBrrpKVFoBh4"};